export default __webpack_public_path__ + "structdata1ac447.png";